























import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Timeline from '@/models/Timeline';

@Component({
	computed: {
		...mapGetters([
            'checkTimelineAdmin'
		])
    }
})
export default class TimelineCopier extends Vue {
    @Prop(Timeline) readonly timeline! : Timeline;

    includeAccess = false;

    duplicateTimeline()
    {
       this.$root.$bvToast.toast('Copying in progress for: ' + this.timeline.name,
        {
            title: 'Timeline Copied',
            variant: 'success',
            autoHideDelay: 5000
        });

        this.timeline.duplicate(this.includeAccess);
        this.$emit('close');
    }
}
